<pk-data-table [shouldNavigateAfterRowClick]='shouldNavigateAfterRowClick'></pk-data-table>
